import React, { useContext, useState, useEffect } from "react";
import { Prices } from "src/enitities/Table";
import { PricesContext } from "src/shared";
import { API } from "src/shared";
import { getFilterData } from "./lib/getFilterData";
import { message } from "antd";

export default function TablePrices() {
  const [messageApi, contextHolder] = message.useMessage();
  const { token, pathname, websocket, params, countData } =
    useContext(PricesContext);
  const [dataSource, setDataSource] = useState();
  const [dataSourceFilter, setDataSourceFilter] = useState([]);

  const [loading, setLoading] = useState(false);
  const handleChanges = async (pagination, filters, sorter, extra) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    let newData = dataSource;
    setLoading(true);
    switch (extra.action) {
      case "filter":
        newData = await getFilterData(filters, pathname, params);
        break;
      default:
        newData = await getFilterData(filters, pathname, params);
    }
    setLoading(false);
    setDataSourceFilter(newData);
  };

  useEffect(() => {
    if (!websocket) return;

    const handlePricesMessage = async (event) => {
      const data = JSON.parse(event.data);
      if (data.target === "prices") {
        setDataSource(data);
      }
    };

    websocket.addEventListener('message', handlePricesMessage);

    return () => {
      websocket.removeEventListener('message', handlePricesMessage);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, websocket?.readyState]);

  return (
    <>
      {contextHolder}
      <Prices
        loading={loading}
        setLoading={setLoading}
        dataSource={dataSource}
        dataSourceFilter={dataSourceFilter}
        countData={countData}
        handleSave={API.crud.edit(token, pathname, messageApi)}
        handleRemove={API.crud.remove(token, pathname, messageApi)}
        handleDeleteImage={API.pictures.removeImage(token, messageApi)}
        handleChanges={handleChanges}
        token={token}
        messageApi={messageApi}
      />
    </>
  );
}
